import React from 'react';
import withIcon from '../utilities/withIcon';

const IconStarFilled = () => {
  return (
    <g>
      <path d="m5.738 5.528-4.999.008-.103.007c-.634.085-.878.933-.34 1.345l4.06 3.105-1.548 5.028-.023.094c-.12.65.623 1.149 1.17.732L8 12.772l4.044 3.075.08.053c.564.332 1.272-.215 1.068-.879l-1.55-5.028 4.062-3.105.078-.069c.457-.454.152-1.282-.521-1.283l-5-.008L8.704.525a.735.735 0 0 0-1.408 0L5.738 5.528z" />
    </g>
  );
};

export default withIcon(IconStarFilled);
